
export function* watchHome() {
  // yield takeLatest(HomeActionType.GET_HOME_DATA, getHomeData);
}

function* getHomeData({ onSuccess }) {
  // yield put({ type: HomeActionType.GET_HOME_DATA_SUCCESS });
}
